export const ENDPOINT_URL = "https://api.libercapital.com.br/api";
